export default "__VITE_ASSET__DtgndFHt__"